import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "管理员", -1)
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addUser, allAdminUser, disableUsers } from '../../api'


export default /*#__PURE__*/_defineComponent({
  __name: 'adminUserLust',
  setup(__props) {

const search = reactive({
  key: "",
})


const loading = ref(false);
const dataSource = ref([]);

const selectedKeys = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "用户ID", width: "260px", key: "userId", align: "center" },
  { title: "账号", key: "userName", align: "center" },
  { title: "状态", key: "state", align: "center", customSlot: "state" },
  { title: "角色", key: "roleSign", align: "center", customSlot: "roleSign" },
  { title: "注册时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
]);


const getAllAdminUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key };
  allAdminUser(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllAdminUser();


const change = (page: any) => {
  getAllAdminUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
const changedelFlag = (row: any) => {
  console.log(row.userId)
  var data = { "key": row.userId, "id": row.delFlag };
  disableUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAdminUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}

//查询接口
const searchUser = () => {
  page.current=1;
  getAllAdminUser();
}



const user = reactive({
  userId: "",
  userName: "",
  passWord: ""
})


const updateUser = (row: any) => {
  user.userId = row.userId;
  user.userName = row.userName;
  user.passWord = "";
  isDisabled.value = true;
  visible11.value = !visible11.value;
}

const layFormRef11 = ref();

const visible11 = ref(false);

const isDisabled = ref(false);

const changeVisible11 = () => {
  user.userId = "";
  user.userName = "";
  user.passWord = "";
  isDisabled.value = false;
  visible11.value = !visible11.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addUser(JSON.stringify(user)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllAdminUser();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;


    }
  }
])



return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  roleSign: _withCtx(({ row }) => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['350px', '300px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: user,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            required: "",
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.userName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.userName) = $event)),
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "passWord"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: user.passWord,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.passWord) = $event)),
                    type: "passWord"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(">")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})